module.exports = __webpack_public_path__ + "105097acd735d1af34a4736da97889f3.png";